import React, { useEffect } from 'react';
import { T, M, A } from 'TOMA';
import styles from './event-products.module.scss';
import ThumbnailProduct from '../../../components/ThumbnailProduct/ThumbnailProduct';
import s from '../../../components/Header/Header.module.scss';
import { ExhibitorRepository } from '../../../services/Exhibitor/Exhibitor.repository';
import { CodificationRepository } from '../../../services/Codification/Codification.repository';
import { EventRepository } from '../../../services/Event/Event.repository';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';

export default function EventProducts(): JSX.Element {
  const [products, setProducts] = React.useState<any[]>([]);
  const [codifications, setCodifications] = React.useState<any[]>([]);
  const [isRefreshing, setIsRefreshing] = React.useState<boolean>(false);

  //   type Codification = {
  //   code: string;
  //   topic: string;
  //   topicCode: string;
  //   label: string;
  //   filter: string;
  // };

  // interface iThumbnailProduct {
  //   id: number;
  //   name: string;
  //   photo: string | null;
  //   logo: string | null;
  //   format: string;
  //   alcool: string;
  //   millesime: string;
  //   raison_sociale: string;
  //   codifications: Codification[];
  //   hall: string;
  //   stand: string;
  // }

  const exhibitorRepo = new ExhibitorRepository();
  const codificationRepo = new CodificationRepository();
  const eventRepo = new EventRepository();

  const { slug } = useParams();
  const [event, setEvent] = React.useState<any>(null);

  useEffect(() => {
    codificationRepo.search().then((data) => {
      setCodifications(data);
    });
  }, []);

  useEffect(() => {
    eventRepo.getPublicEventBySlug(slug ?? '').then((data) => {
      const eventData = Array.isArray(data) ? data[0] : data;
      setEvent({
        ...eventData,
        logo:
          eventData.company_logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${eventData.company_logo_uuid}.${eventData.company_logo_extension}`
            : null,
      });
    });
  }, [slug]);

  useEffect(() => {
    // Fetch codifications if needed
    if (codifications.length === 0) return;
    exhibitorRepo.eventProducts(slug ?? '').then((data) => {
      console.log('Fetched products:', data);
      const updatedProducts = data.data.map((res: any) => ({
        ...res,
        photo: res.uuid
          ? `${process.env.REACT_APP_API_URL ?? ''}/storage/uploads/640/${
              res.uuid
            }.${res.extension}`
          : null,
        logo: `${process.env.REACT_APP_API_URL ?? ''}/storage/uploads/640/${
          res.logo_uuid
        }.${res.logo_extension}`,
      }));
      setProducts(updatedProducts);
      console.log('Updated products:', updatedProducts); // ✅ correct place
    });
  }, [codifications]);
  console.log('Products state:', products);
  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <>
      {event && (
        <div style={{ backgroundColor: event.color || '#000000' }}>
          <T.Block>
            <T.Container>
              <T.Flex halign="space-between" py="40" gap={4}>
                <T.Col>
                  <>
                    <T.Block my="10">
                      <A.Image
                        className="hidden"
                        src={event.logo || ''}
                        height="40"
                        width="auto"
                      />
                    </T.Block>
                    <A.Text color="white" mb="10" fontSize="24" fw="bold">
                      {event.name}
                    </A.Text>
                    <A.Text color="white" mb="10" fontSize="18">
                      {event.subtitle}
                    </A.Text>
                    <div className={s.Header__line}></div>

                    <T.Block mt="15">
                      <A.Text color="white" fontSize="18">
                        <T.Flex className="flex" gap={1}>
                          <div>
                            <A.Icon icon="calendar2-week-fill" color="white" />
                          </div>
                          <div>
                            Du {event?.date} au {event?.date_of_the_end}
                          </div>
                          <div>
                            <A.Icon icon="geo-fill" color="white" />
                          </div>
                          <div>
                            {event.city}, {event.country}
                          </div>
                        </T.Flex>
                      </A.Text>
                    </T.Block>
                  </>
                </T.Col>
              </T.Flex>
            </T.Container>
          </T.Block>
        </div>
      )}
      <div className={styles.ExhibitorList}>
        <BreadCrumb
          breadCrumb={[
            // {
            //   icon: null,
            //   href: '/' + BASE_PATH + '/preview/events',
            //   label: 'Events',
            //   isCurrent: false,
            // },
            {
              icon: null,
              href: undefined,
              label: event ? event.name : 'Event',
              isCurrent: true,
            },
            {
              icon: null,
              href: `/${BASE_PATH}/preview/events/${slug ?? ''}/exhibitors`,
              label: 'List Of Exhibitors',
              isCurrent: false,
            },
            {
              icon: null,
              href: undefined,
              label: 'List of Products',
              isCurrent: false,
            },
          ]}
        />
        <h1 className={styles.ExhibitorList__title}>List of Products</h1>
        <M.Loading loading={isRefreshing} overlay>
          {products.length === 0 && (
            <div className={styles.ExhibitorList__nofound}>
              No product found...
            </div>
          )}

          <ul className={styles.ExhibitorList__List}>
            {products.map(
              ({
                id,
                logo,
                name,
                raison_sociale,
                hall,
                stand,
                photo,
                format,
                alcool,
                millesime,
              }) => (
                <li className={styles.ExhibitorList__List__li} key={id}>
                  <ThumbnailProduct
                    id={id}
                    logo={logo}
                    name={name}
                    raison_sociale={raison_sociale}
                    photo={photo}
                    format={format}
                    alcool={alcool}
                    millesime={millesime}
                    codifications={codifications}
                    hall={hall}
                    stand={stand}
                    slug={slug ?? ''}
                  />
                </li>
              )
            )}
          </ul>
        </M.Loading>
      </div>
    </>
  );
}
